import * as React from 'react';
import styled from 'styled-components';

const StyledDevicesStateBox = styled.div<{ turnedOn?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme, turnedOn }) =>
    turnedOn && turnedOn > 0
      ? theme.colors.secondary
      : 'rgba(18, 18, 18, 0.38)'};
  color: ${({ theme, turnedOn }) =>
    turnedOn && turnedOn > 0 ? 'rgba(55, 59, 64, 0.87)' : theme.colors.white};
  width: 56px;
  height: 20px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  user-select: none;
`;

export interface IDevicesStateBoxProps {
  devicesTurnedOn?: number;
}

const DevicesStateBox: React.FunctionComponent<IDevicesStateBoxProps> = props => {
  const { devicesTurnedOn } = props;
  return (
    <StyledDevicesStateBox turnedOn={devicesTurnedOn}>
      {devicesTurnedOn || 0} ON
    </StyledDevicesStateBox>
  );
};

export default DevicesStateBox;
